'use strict';
const goldAsset = require('./gold-asset');
module.exports = function GoldAttachmentUnpacker(navigatorShim, pageState) {
	if (!navigatorShim) {
		throw 'invalid-args';
	}
	const self = this,
		unpackAttachmentAssetsFromSameMap = function (ideaArray, fileId) {
			if (!fileId || !ideaArray || !ideaArray.length) {
				return ideaArray || [];
			}
			const otherIdeas = [];
			ideaArray.forEach(function (idea) {
				const attachment = idea && idea.attr && idea.attr.attachment,
					attachmentMetadata = attachment && goldAsset.isGoldAssetMetadata(attachment.content);

				if (attachmentMetadata && attachmentMetadata.fileId === fileId) {
					attachment.goldAssetId = goldAsset.resourceIdFromAssetId(attachmentMetadata.assetId);
					delete attachment.content;
				} else if (attachmentMetadata) {
					otherIdeas.push(idea);
				} else if (attachment && attachment.atlasUrl)  {
					otherIdeas.push(idea);
				}
			});
			return otherIdeas;
		},
		downloadRemoteAttachmentAssetsForSingleIdea = function (idea) {
			const attachment = idea && idea.attr && idea.attr.attachment,
				attachmentMetadata = attachment && goldAsset.isGoldAssetMetadata(attachment.content),
				attachmentUrl = (attachmentMetadata && attachmentMetadata.contentUrl) || (attachment && attachment.atlasUrl && attachment.content);

			if (!attachmentUrl) {
				return Promise.resolve();
			}
			return navigatorShim.downloadAsDataUri(attachmentUrl).then(function (dataUri) {
				attachment.content = dataUri;
				attachment.dataUriEncoded = true;
				delete attachment.atlasUrl;
				delete attachment.remoteUrl;
			}).catch(() => delete idea.attr.attachment);
		};
	self.unpack = function (ideaArray) {
		const fileId = pageState && pageState.getFileId(),
			ideasWithDownloadableAttachments = unpackAttachmentAssetsFromSameMap(ideaArray, fileId);
		return Promise.all(ideasWithDownloadableAttachments.map(downloadRemoteAttachmentAssetsForSingleIdea));
	};
};
